import React from 'react';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import ProfileImage from '@fiverr-private/profile_image/src/ProfileImage';
import { Avatar, AvatarImage } from '@fiverr-private/avatar';
import { getContext } from '@fiverr-private/fiverr_context';

interface SellerAvatarParams {
  profilePhoto: string;
  hasProfilePhoto: boolean;
}

export const SellerAvatar = ({ profilePhoto, hasProfilePhoto }: SellerAvatarParams) => {
  const {
    seller: { isAgency, introVideoUrl, isPro: isProSeller },
  } = useGigPageContext();

  const { pathParameters, locale } = getContext();
  const { username } = pathParameters;

  const avatarShape = isAgency ? 'square' : 'circle';

  const profileImageUserProps = {
    username,
    has_profile_photo: hasProfilePhoto,
    profile_photo: profilePhoto,
    is_pro: isProSeller,
    is_seller: true,
  };

  if (isAgency) {
    return (
      <Avatar size="2xl" shape={avatarShape} username={username}>
        <AvatarImage src={profilePhoto} alt={username} />
      </Avatar>
    );
  }

  return <ProfileImage introVideo={introVideoUrl} user={profileImageUserProps} profileImageSize={96} locale={locale} />;
};
